import { render, staticRenderFns } from "./ups-downs-futures.vue?vue&type=template&id=4f1e9230&scoped=true"
import script from "./ups-downs-futures.vue?vue&type=script&lang=js"
export * from "./ups-downs-futures.vue?vue&type=script&lang=js"
import style0 from "./ups-downs-futures.vue?vue&type=style&index=0&id=4f1e9230&prod&lang=css"
import style1 from "./ups-downs-futures.vue?vue&type=style&index=1&id=4f1e9230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e9230",
  null
  
)

export default component.exports